import { visserApi } from './visserApi';
const getCurrentUserDetails = () => {
    return visserApi.get('freelancer/user-detail');
};
const UserApi = {
    getCurrentUserDetails
};
export default UserApi;
